// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__SJjNo","modalFooterButton":"ModalNotes_modalFooterButton__SGtAt"};